 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/Acknowledgments'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTPARTONE from '@/components/Text/PARTONE'
 import TEXTSSWCH1 from '@/components/Text/SSWCh1'
 import TEXTSSWCH2 from '@/components/Text/SSWCh2'
 import TEXTSSWCH3 from '@/components/Text/SSWCh3'
 import TEXTSSWCH4 from '@/components/Text/SSWCh4'
 import TEXTSSWCH5 from '@/components/Text/SSWCh5'
 import TEXTSSWCH6 from '@/components/Text/SSWCh6'
 import TEXTSSWCH7 from '@/components/Text/SSWCh7'
 import TEXTPARTTWO from '@/components/Text/PARTTWO'
 import TEXTSSWCH8 from '@/components/Text/SSWCh8'
 import TEXTSSWCH9 from '@/components/Text/SSWCh9'
 import TEXTSSWCH10 from '@/components/Text/SSWCh10'
 import TEXTNOTES from '@/components/Text/Notes'
 import TEXTGLOSSARY from '@/components/Text/Glossary'
 import TEXTFURTHERREADING from '@/components/Text/FurtherReading'
 import TEXTSUBJECTINDEX from '@/components/Text/SubjectIndex'
 import TEXTSCRIPTUREINDEX from '@/components/Text/ScriptureIndex'
 import TEXTAUTHOR from '@/components/Text/author'
 import TEXTENDORSEMENTS from '@/components/Text/Endorsements'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/title",
 			"name" : "Text/title",
 			"component" : TEXTTITLE
 		},
 		{
 			"path" : "/Text/copyright",
 			"name" : "Text/copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/dedication",
 			"name" : "Text/dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/Acknowledgments",
 			"name" : "Text/Acknowledgments",
 			"component" : TEXTACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/PARTONE",
 			"name" : "Text/PARTONE",
 			"component" : TEXTPARTONE
 		},
 		{
 			"path" : "/Text/SSWCh1",
 			"name" : "Text/SSWCh1",
 			"component" : TEXTSSWCH1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js